import { render } from "./organicSustainableScreen.vue?vue&type=template&id=9f6514ba"
import script from "./organicSustainableScreen.vue?vue&type=script&lang=js"
export * from "./organicSustainableScreen.vue?vue&type=script&lang=js"

import "./organicSustainableScreen.vue?vue&type=style&index=0&id=9f6514ba&lang=scss"

import exportComponent from "F:\\freelance\\web development\\project twelve\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__